import { UserServiceType } from './interface';
import { GetUserListByIdsParams, GetUserListParams, GetUserListParamsByQuery } from './types';
import { User } from '@sentry/react';
import axiosInstance from '@/api';
import { IUsersData } from '@/entities/admin-app/users';
import { IQueryUsersTable } from '@/types/api';

/** Класс фабрика UserService который хранит в себе API методы для работы с группами **/
export class UserService implements UserServiceType {
  async LoadUsersForWidgetSection(): Promise<IUsersData> {
    const params: IQueryUsersTable = {
      Count: 20,
      Offset: 0,
      SortOrder: 0,
      SortField: 0,
      Filters: {},
      Query: '',
      FilterConditions: []
    };

    try {
      const res = await axiosInstance.post('v2/Profile/Users', params);
      return res.data.Response.Data;
    } catch (e) {
      throw new Error(`Error: ${e}`);
    }
  }

  async GetUserList(params: GetUserListParams): Promise<User[]> {
    try {
      const res = await axiosInstance.post('v1/User/search', params);
      return res.data;
    } catch (e) {
      throw new Error(`Error: ${e}`);
    }
  }

  async GetUserListByQuery(params: GetUserListParamsByQuery): Promise<any> {
    const paramsToRequest = {
      Query: params.query,
      SortOrder: 0,
      SortOrderField: 'Email',
      Size: 5,
      Offset: 0
    };
    try {
      const res = await axiosInstance.post('v1/User/search', paramsToRequest);
      return res.data;
    } catch (e) {
      throw new Error(`Error: ${e}`);
    }
  }

  async GetUserListByIds(params: GetUserListByIdsParams): Promise<User[]> {
    try {
      const res = await axiosInstance.post('v1/User/get', params);

      return res.data;
    } catch (e) {
      throw new Error(`Error: ${e}`);
    }
  }
}
